__turbopack_context__.v({
  "className": "space_grotesk_a00682b6-module__i6V0Fq__className",
});
